import {fetchJSONByGet, fetchJSONByPost} from './index.js'

// Country & Language
// 创建
export const newItemApi = (body) => fetchJSONByPost('/adms_api_v0/google/language', body)
// 获取列表
export const getListApi = (params, trigger = false) => fetchJSONByGet('/adms_api_v0/google/language/page', params, {trigger})
// 激活/关闭
export const activeItemApi = (id, active) => fetchJSONByPost(`/adms_api_v0/google/language/${id}/${active}`)
// 批量激活/关闭
export const activeItemsApi = (body, active) => fetchJSONByPost(`/adms_api_v0/google/language/batch/${active}`, body)
// 更新
export const updateItemApi = (id, body) => fetchJSONByPost(`/adms_api_v0/google/language/${id}`, body)
// 获取某一
export const getItemApi = (id) => fetchJSONByGet(`/adms_api_v0/google/language/${id}`)